import { ActualPrice } from 'components/BundlePrice/ActualPrice';
import React, { useState } from 'react';
import { BundlePriceProps } from 'utils/types';
import {
  StyledSubRollingOfferPrice,
  StyledSubRollingOfferPriceButton,
} from './style';
import { AnimatePresence, motion } from 'framer-motion';
import openLock from 'assets/RollingOffers/open_lock.png';

interface ISubRollingOfferPriceProps extends BundlePriceProps {
  index: number;
  lockImage?: string;
  setIsAnimatingPrice: (isAnimating: boolean) => void;
}

export const SubRollingOfferPrice: React.FC<ISubRollingOfferPriceProps> = ({
  index,
  prices,
  whiteStripe = true,
  buttonText = 'Collect',
  lockImage = '',
  buttonColor,
  setIsAnimatingPrice,
}) => {
  const [displayOpenLock, setDisplayOpenLock] = useState<boolean>(false);

  return (
    <StyledSubRollingOfferPriceButton background={buttonColor}>
      {whiteStripe && <div className="white_stripe"></div>}
      <AnimatePresence onExitComplete={() => setDisplayOpenLock(true)}>
        {lockImage && (
          <motion.img
            key={index}
            src={lockImage}
            alt="Lock"
            width="15px"
            className="lockImage"
            exit={{
              rotate: [0, 50, -50, 50, -50, 50, 0],
            }}
            transition={{
              rotate: { delay: 0.5, duration: 1 },
            }}
            onAnimationStart={() => setIsAnimatingPrice(true)}
            onAnimationComplete={() => setIsAnimatingPrice(false)}
          />
        )}
        <motion.img
          key={`${index}_open`}
          src={openLock}
          alt="Lock"
          width="15px"
          className="lockImage"
          initial={{ scale: 1 }}
          animate={{ scale: displayOpenLock ? 0 : 1 }}
          transition={{
            scale: { delay: 0.4, duration: 0.2 },
          }}
          style={{ visibility: displayOpenLock ? 'visible' : 'hidden' }}
        />
      </AnimatePresence>
      <StyledSubRollingOfferPrice>
        <div className="totalPrice">
          {!prices?.priceInUsdCents ? (
            <span>{buttonText}</span>
          ) : (
            <ActualPrice
              prices={prices}
              textShadow="0px 2px 2px rgba(0, 0, 0, 0.25)"
            />
          )}
        </div>
      </StyledSubRollingOfferPrice>
    </StyledSubRollingOfferPriceButton>
  );
};
